import { render, staticRenderFns } from "./brandInformation.vue?vue&type=template&id=1a5bd62d&"
import script from "./brandInformation.vue?vue&type=script&lang=js&"
export * from "./brandInformation.vue?vue&type=script&lang=js&"
import style0 from "./brandInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports